import { Fragment, memo, ReactElement } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import FormFilter from './form';
import { ResearchAct } from 'civil-status/view-models/research-category-form';

interface AccordionFilterActProps {
  open?: boolean;
  setOpen: (value: boolean) => void;
  idCat?: string;
  handleSubmitResearchAct: (values: ResearchAct) => void;
  isWithoutInitialContext?: boolean;
  disabledRegister?: boolean;
  disabledMunicipality?: boolean;
}

const AccordionFilterActComponent = ({
  open,
  setOpen,
  idCat,
  handleSubmitResearchAct,
  disabledRegister,
  disabledMunicipality,
  isWithoutInitialContext,
}: AccordionFilterActProps): ReactElement => {
  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="filter-act-content"
          id="panel-filter-act-header"
          classes={{
            root: 'pmi-flex-row-reverse',
          }}
          expandIcon={<ExpandMore />}
        >
          <Typography>Filtri di ricerca per atto</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <FormFilter
            idCat={idCat}
            handleSubmitResearchAct={handleSubmitResearchAct}
            disabledRegister={disabledRegister}
            disabledMunicipality={disabledMunicipality}
            isWithoutInitialContext={isWithoutInitialContext}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFilterActComponent.displayName = 'Practice Research - Filter Practice component';

const AccordionFilterAct = memo(AccordionFilterActComponent);

export default AccordionFilterAct;
